export const LINKED_TRANSACTION_FIELD = {
  CONNECTOR_NAME: 'connector_name',
  ACCOUNT_NAME: 'account_name',
  ACCOUNT_NUMBER: 'account_number',
  ACCOUNT_TYPE: 'account_type',
  TAGS: 'tags',
  YEAR: 'year',
  QUARTER: 'quarter',
  MONTH: 'month',
  DATE: 'date',
  OVERRIDE_DATE: 'override_date',
  TYPE: 'type',
  ACCESS_METHOD: 'access_method',
  CATEGORY: 'category',
  SUBCATEGORY: 'subcategory',
  COUNTERPARTY: 'counterparty',
  DESCRIPTION: 'description',
  AMOUNT: 'amount',
  STATUS: 'status',
}

export const LINKED_TRANSACTION_LABEL = {
  [LINKED_TRANSACTION_FIELD.CONNECTOR_NAME]: 'Connector',
  [LINKED_TRANSACTION_FIELD.ACCOUNT_NAME]: 'Account name',
  [LINKED_TRANSACTION_FIELD.ACCOUNT_NUMBER]: 'Account number',
  [LINKED_TRANSACTION_FIELD.ACCOUNT_TYPE]: 'Account type',
  [LINKED_TRANSACTION_FIELD.TAGS]: 'Tags',
  [LINKED_TRANSACTION_FIELD.YEAR]: 'Year',
  [LINKED_TRANSACTION_FIELD.QUARTER]: 'Quarter',
  [LINKED_TRANSACTION_FIELD.MONTH]: 'Month',
  [LINKED_TRANSACTION_FIELD.DATE]: 'Date',
  [LINKED_TRANSACTION_FIELD.OVERRIDE_DATE]: 'Override date',
  [LINKED_TRANSACTION_FIELD.TYPE]: 'Transaction type',
  [LINKED_TRANSACTION_FIELD.ACCESS_METHOD]: 'Access method',
  [LINKED_TRANSACTION_FIELD.CATEGORY]: 'Category',
  [LINKED_TRANSACTION_FIELD.SUBCATEGORY]: 'Subcategory',
  [LINKED_TRANSACTION_FIELD.COUNTERPARTY]: 'Counterparty',
  [LINKED_TRANSACTION_FIELD.DESCRIPTION]: 'Description',
  [LINKED_TRANSACTION_FIELD.AMOUNT]: 'Amount',
  [LINKED_TRANSACTION_FIELD.STATUS]: 'Status',
}

// Columns hidden by default until the user opts them in via columns management.
export const LINKED_TRANSACTIONS_DEFAULT_HIDDEN_COLUMNS = [
  LINKED_TRANSACTION_FIELD.OVERRIDE_DATE,
  LINKED_TRANSACTION_FIELD.YEAR,
  LINKED_TRANSACTION_FIELD.QUARTER,
  LINKED_TRANSACTION_FIELD.MONTH,
]

export const LINKED_TRANSACTIONS_SEARCH_KEY = [
  'linked-data',
  'transactions',
  'search',
]
export const LINKED_TRANSACTIONS_FILTER_KEY = [
  'linked-data',
  'transactions',
  'filter',
]
export const LINKED_TRANSACTIONS_SORT_KEY = [
  'linked-data',
  'transactions',
  'sort',
]
export const LINKED_TRANSACTIONS_PAGE_SIZE_KEY = [
  'linked-data',
  'transactions',
  'pageSize',
]
export const LINKED_TRANSACTIONS_COLUMNS_KEY = [
  'linked-data',
  'transactions',
  'columns',
]

export const LINKED_DATA_POSITIONS_SEARCH_KEY = [
  'linked-data',
  'positions',
  'search',
]
export const LINKED_DATA_POSITIONS_FILTER_KEY = [
  'linked-data',
  'positions',
  'filter',
]
export const LINKED_DATA_POSITIONS_SORT_KEY = [
  'linked-data',
  'positions',
  'sort',
]

export const ACCOUNT_TAG_PREFIX = 'account_tag:'
